<template>
	<div class="animated fadeIn">
		<div class="row pageinfo">
      <b-col lg="6">
		<h2 v-show="!trash">Fluid Transportation Agreement</h2>
        <h2 v-show="trash">Fluid Transportation Agreement - Trash</h2>
      </b-col>
    </div>
		<div class="card">
		    <div class="card-body">
			    <b-row>
		        	<b-container fluid>
						<b-row>
							<b-col lg="4" class="my-1">
								<div class="input-group mb-3">
									<div class="input-group-prepend">
										<b-form-input v-model="filter" placeholder="Search" />
										<b-btn class="brad-0" :disabled="!filter" @click="filter = ''">Clear</b-btn>
									</div>
								</div>
							</b-col>
							<b-col lg="3" class="my-1">
								<b-dropdown class="pull-left" :text="dpdt">
									<b-dropdown-item @click="trashAgreement()">Active</b-dropdown-item>
									<b-dropdown-item @click="trashAgreement()">Trash</b-dropdown-item>
								</b-dropdown>
							</b-col>
							<b-col lg="5" class="my-1">
								<b-button @click="showNewModal()" :disabled="loadingData" variant="primary" class="pull-right" >New Agreement</b-button>
							</b-col>
							<b-col v-if="role =='super_admin'" class="my-1 f7" sm="6" md="2" title="Energy Companies">
								<b-dropdown class="custom_dropdown custom_dropdown_b" @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop"  :text="filter_agree.energy_company" >
									<b-dropdown-item @click="ecFilter('All Energy Companies', 0)">All Energy Companies</b-dropdown-item>
									<b-dropdown-item v-for="energy_company_filter in energy_companies_filter" @click="ecFilter(energy_company_filter.company_name, energy_company_filter.id)">{{energy_company_filter.company_name}}</b-dropdown-item>
								</b-dropdown>
							</b-col>
							<b-col class="my-1 f7" sm="6" md="2" title="Trucking Companies" >
								<b-dropdown class="custom_dropdown custom_dropdown_b" @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop" :text="filter_agree.trucking_company">
									<b-dropdown-item @click="tcFilter('All Trucking Companies', 0)"><h6>All Trucking Companies</h6></b-dropdown-item>
									<b-dropdown-item v-for="trucking_company_filter in trucking_companies_filter" @click="tcFilter(trucking_company_filter.name, trucking_company_filter.id)">{{trucking_company_filter.name}}</b-dropdown-item>
								</b-dropdown>
							</b-col>
					
							<b-col class="my-1 f7" sm="6" md="2">
								<b-dropdown class="custom_dropdown custom_dropdown_b" @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop"  :text="filter_agree.load_locations" title="Load Locations">
									<b-dropdown-item @click="lFilter('All Load Locations', 0)">All Load Locations</b-dropdown-item>
									<b-dropdown-item v-for="load_location_filter in load_locations_filter" @click="lFilter(load_location_filter.legal_location, load_location_filter.id)">{{load_location_filter.legal_location}}</b-dropdown-item>
								</b-dropdown>
							</b-col>
							<b-col class="my-1 f7" sm="6" md="2">
								<b-dropdown class="custom_dropdown custom_dropdown_b" @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop"  :text="filter_agree.unload_locations" title="Unload Locations">
									<b-dropdown-item @click="uFilter('All Unload Locations', 0)">All Unload Locations</b-dropdown-item>
									<b-dropdown-item v-for="unload_location_filter in unload_locations_filter" @click="uFilter(unload_location_filter.legal_location, unload_location_filter.id)">{{unload_location_filter.legal_location}}</b-dropdown-item>
								</b-dropdown>
							</b-col>
							<b-col class="my-1 f7" sm="6" md="2">
								<b-dropdown class="custom_dropdown custom_dropdown_b" @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop"  :text="filter_agree.truck_types" title="TruckTypes">
								<b-dropdown-item @click="ttFilter('All Truck Types', 0)">All Truck Types</b-dropdown-item>
								<b-dropdown-item v-for="truck_type_filter in truck_types_filter" @click="ttFilter(truck_type_filter.name, truck_type_filter.id)">{{truck_type_filter.name}}</b-dropdown-item>
								</b-dropdown>
							</b-col> 
						</b-row>
		        		<b-row v-if="loadingData">
			              <b-col cols="12" sm="12" md="12" lg="12">
			                 <p class="text-center">
			                   <i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br>Loading data...
			                 </p>
			              </b-col>
			            </b-row>
			            <b-table class="animated fadeIn" v-else 
							striped 
							hover 
							bordered 			
							show-empty
                     		stacked="md"
							:sort-by.sync="sortBy"
							:sort-desc.sync="sortDesc"
                     		:items="items"
                     		:fields="fieldsTh"
                     		:current-page="currentPage"
                     		:per-page="perPage"
                     		:filter="filter"
                     		@filtered="onFiltered"
							@row-clicked="rowClicked"
            			>
				            <template slot="details" slot-scope="row">
				                <center>
				                  <b-button size="sm" variant="info" @click.stop="row.toggleDetails">
				                    <i v-show="row.detailsShowing" class="fa fa-angle-double-up"></i>
				                    <i v-show="!row.detailsShowing" class="fa fa-angle-double-right"></i>
				                  </b-button>
				                </center>
				            </template>
				            <template slot="row-details" slot-scope="row">
				                <b-card>
				                    <ul>
				                      <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value}}</li>
				                    </ul>
				                </b-card>
				            </template>

							<template slot="load_locations_l" slot-scope="row">
								<p v-for="(load_location, index) in row.item.load_locations_l" :key="index">
									{{load_location}}
								</p>
				            </template>
							<template slot="unload_locations_l" slot-scope="row">
								<p v-for="(unload_location, index) in row.item.unload_locations_l" :key="index">
									{{unload_location}}
								</p>
				            </template>
							<template slot="fluidtypes" slot-scope="row">
								<p v-for="(fluidtype, index) in row.item.fluidtypes" :key="index">
									{{fluidtype}}
								</p>
				            </template>
							<template slot="truck_types_l" slot-scope="row">
								<p v-for="(truck_type, index) in row.item.truck_types_l" :key="index">
									{{truck_type}}
								</p>
				            </template>
            			</b-table>
            			<!-- User Interface controls -->
						<b-row>
							<b-col lg="2" md="2" sm="12" class="my-1 pull-right">
								<div class="input-group mb-3">
									<div class="input-group-prepend"> </div>
									<b-select :options="pageOptions" v-model="perPage" />
								</div>
							</b-col>
							<b-col lg="10" md="10" sm="12" class="my-1">
								<b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-1 pull-right" />
							</b-col>
						</b-row>
            			<!-- Info modal -->
			            <b-modal id="modalInfo" @hide="resetModal" :title="modalInfo.title" ok-only>
			              <pre>{{ modalInfo.content }}</pre>
			            </b-modal>
			            <!--End ModalInfo-->
					</b-container>
				</b-row>
		    </div>
		</div>

		<!-- Add new Terminal Agreement Modal name="plain-inline"-->
		<b-modal title="New Agreement" id="newModal" ref="newAgreements" v-model="newAgreements" size="lg">
			<div>
				<b-card no-body>
					<b-tabs card v-model="modalTabIndex">
						<b-tab title="Basic Info" active>
							<b-row>
								<b-col sm="6">
									<b-form-group :label-cols="3" id="L1" label="Location Based Contract" label-for="radio-group-1" vertical>
										<b-form-radio-group
											id="radio-group-1"
											v-model="model.located_based"
											:options="options"
											plain		
										></b-form-radio-group>						
									</b-form-group>
								</b-col>
							</b-row>
							<b-row>
								<b-col sm="6">
									<b-form-group :label-cols="3" id="L11" label="Fluid Type Based Contract" label-for="radio-group-4" vertical>
										<b-form-radio-group
											id="radio-group-4"
											v-model="model.fluid_based"
											:options="options"
											plain		
										></b-form-radio-group>						
									</b-form-group>
								</b-col>
							</b-row>
							<b-row>
								<b-col >
									<b-form-group :label-cols="3" vertical label="Initial Date" label-for="initial_date">
										<b-form-input id="initial_date" v-model="model.initial_date" type="date"></b-form-input>
									</b-form-group>
								</b-col>
								<b-col sm="6">
									<b-form-group :label-cols="3" vertical label="End Date" label-for="end_date">
										<b-form-input id="end_date" v-model="model.end_date" type="date"></b-form-input>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row>
								<b-col sm="6" v-if="role =='super_admin'">					
									<b-form-group :label-cols="3" vertical label="Energy Company" label-for="energyCompanies">
										<b-form-select id="energyCompanies" v-model="model.energy_company_id" :options="energyCompanies" @input="select_energy_companies()">
											<template slot="first"><option :value="null" disabled>-- select energy company --</option></template>
										</b-form-select>
									</b-form-group>
								</b-col>
								<b-col sm="6">					
									<b-form-group :label-cols="3" vertical label="Trucking Company" label-for="truckingCompanies">
										<b-form-select id="truckingCompanies" v-model="model.trucking_company_id" :options="truckingCompanies" @input="select_trucking_companies()">
											<template slot="first"><option :value="null" disabled>-- select trucking company --</option></template>
										</b-form-select>
									</b-form-group>
								</b-col>
							</b-row>	
							<b-row>
								<b-col sm="6">					
									<b-form-group :label-cols="3" vertical label="Regular Charge" label-for="regular_charge">
										<b-form-select id="regular_charge" v-model="model.regular_charge_id" :options="chargeTypes">
												<template slot="first"><option :value="null" disabled>-- select regular charge --</option></template>
										</b-form-select>
									</b-form-group>
								</b-col>
								<b-col sm="6">					
										<b-form-group :label-cols="3" vertical label="Regular Rate" label-for="regular_rate">
											<b-form-input id="regular_rate" v-model="model.regular_rate" type="text" @keydown.native="myOnlyNumber($event, 'regular_rate')"></b-form-input>
										</b-form-group>
								</b-col>
							</b-row>
							<b-row>
								<b-col sm="6">					
									<b-form-group :label-cols="3" vertical label="Standby Time Charge" label-for="stb_charge">
										<b-form-select id="stb_charge" v-model="model.stb_charge_id" :options="chargeTypes">
												<template slot="first"><option :value="null" disabled>-- select standby time charge --</option></template>
										</b-form-select>
									</b-form-group>
								</b-col>
								<b-col sm="6">					
										<b-form-group :label-cols="3" vertical label="Standby Time Rate" label-for="stb_rate">
											<b-form-input id="stb_rate" v-model="model.stb_rate" type="text" @keydown.native="myOnlyNumber($event, 'stb_rate')"></b-form-input>
										</b-form-group>
								</b-col>
							</b-row>
							<b-row>
								<b-col sm="6">					
									<b-form-group :label-cols="3" vertical label="Worktime Charge" label-for="worktime_charge">
										<b-form-select id="worktime_charge" v-model="model.worktime_charge_id" :options="chargeTypes">
												<template slot="first"><option :value="null" disabled>-- select worktime charge --</option></template>
										</b-form-select>
									</b-form-group>
								</b-col>
								<b-col sm="6">					
										<b-form-group :label-cols="3" vertical label="Worktime Rate" label-for="worktime_rate">
											<b-form-input id="worktime_rate" v-model="model.worktime_rate" type="text" @keydown.native="myOnlyNumber($event, 'worktime_rate')"></b-form-input>
										</b-form-group>
								</b-col>
							</b-row>
							<b-row>
								<b-col sm="6">
									<b-form-group :label-cols="3" id="L2" label="Wait Time Discount?" label-for="radio-group-2" vertical>
										<b-form-radio-group
											id="radio-group-2"
        							v-model="model.wait_time_discount"
        							:options="options"
        							plain
      							></b-form-radio-group>						
									</b-form-group>
									<b-form-group :label-cols="3" id="L3" label="Would you like to round to the nearest 15min? " label-for="radio-group-3" vertical>
										<b-form-radio-group
											id="radio-group-3"
        							v-model="model.rounding"
        							:options="options"
        							plain
      							></b-form-radio-group>						
									</b-form-group>
								</b-col>
								<b-col sm="6" v-if="model.regular_charge_id != null && model.regular_rate != null">		
									<b-form-group :label-cols="3" vertical label="Chain Up Rate" label-for="chain_up_rate">
										<b-form-input id="chain_up_rate" v-model="model.chain_up_rate" type="text" @keydown.native="myOnlyNumber($event, 'chain_up_rate')"></b-form-input>
									</b-form-group>			
								</b-col>
							</b-row>
						</b-tab>
						<b-tab title="Truck Types">
							<b-form-group v-if="truckTypes.length > 0" :label-cols="1" id="L5" label="" label-for="loadLocationsID" vertical>
								<b-form-checkbox-group value-field="id" text-field="name" class="custom-checkboxes" :options="truckTypes" name="Checkboxes2" plain v-model="model.truck_type_id" @input="trucktypesChange"></b-form-checkbox-group>
								<b-form-checkbox style="margin-top: 15px;" v-model="ttAllSelected" :indeterminate="indeterminateTT" aria-describedby="" aria-controls="" plain @change="ttToggleAll">
									{{ ttAllSelected ? 'Un-select All' : 'Select All' }}
								</b-form-checkbox>
							</b-form-group>
							<p v-else>{{model.trucking_company_id != null ? 'There are no registered Truck Types for the selected Trucking Company' : 'No Trucking Company selected'}}</p>
						</b-tab>
						<b-tab v-if="model.located_based =='true'" title="Load Locations">
							<b-form-group v-if="loadlocationselect.length > 0" :label-cols="1" id="L6" label="" label-for="loadLocationsID" vertical>
								<b-form-checkbox-group value-field="id" text-field="legal_location"  class="custom-checkboxes" :options="loadlocationselect" name="Checkboxes2" plain v-model="model.load_locations_id" @input="loadLocationsChange"></b-form-checkbox-group>
								<b-form-checkbox style="margin-top: 15px;" v-model="llAllSelected" :indeterminate="indeterminateLL" aria-describedby="" aria-controls="" plain @change="LLToggleAll">
									{{ llAllSelected ? 'Un-select All' : 'Select All' }}
								</b-form-checkbox>
							</b-form-group>
							<p v-else>{{model.energy_company_id != null ? 'There are no registered Load locations for the selected Energy Company' : 'No Energy Company selected'}}</p>
						</b-tab>
						<b-tab v-if="model.located_based =='true'" title="Unload Locations">
							<b-form-group v-if="unloadlocationselect.length > 0" :label-cols="1" id="L7" label="" label-for="unloadLocationsID" vertical>
								<b-form-checkbox-group value-field="id" text-field="legal_location"  class="custom-checkboxes" :options="unloadlocationselect" name="Checkboxes2" plain v-model="model.unload_locations_id" @input="unloadLocationsChange"></b-form-checkbox-group>
								<b-form-checkbox style="margin-top: 15px;" v-model="ulAllSelected" :indeterminate="indeterminateUL" aria-describedby="" aria-controls="" plain @change="ULToggleAll">
									{{ ulAllSelected ? 'Un-select All' : 'Select All' }}
								</b-form-checkbox>
							</b-form-group>
							<p v-else>{{model.energy_company_id != null ? 'There are no registered Unoad locations for the selected Energy Company' : 'No Energy Company selected'}}</p>
						</b-tab>
						<b-tab v-if="model.fluid_based =='true'" title="Fluid Types">
							<b-form-group v-if="fluidtypeselect.length > 0" :label-cols="1" id="L8" label="" label-for="fluid_type" vertical>
								<b-form-checkbox-group value-field="id" text-field="name"  class="custom-checkboxes" :options="fluidtypeselect" name="Checkboxes2" plain v-model="model.fluid_types_id" @input="fluidtypesChange()"></b-form-checkbox-group>
								<b-form-checkbox style="margin-top: 15px;" v-model="ftAllSelected" :indeterminate="indeterminateFT" aria-describedby="" aria-controls="" plain @change="FTToggleAll">
									{{ ftAllSelected ? 'Un-select All' : 'Select All' }}
								</b-form-checkbox>
							</b-form-group>
							<p v-else>No fluid type registered</p>
						</b-tab>
					</b-tabs>	
				</b-card>
			</div>
			<div slot="modal-footer" class="w-100">
				<b-btn size="md" variant="secondary" @click="newAgreements=false" class="float-left">Cancel</b-btn>
				<b-btn :disabled="savebtn" size="md" variant="primary" @click="saveAgreements" class="float-right">Save</b-btn>
			</div>
		</b-modal> 
		<!-- End Add new Terminal Agreement -->
	</div>
</template>
<style>
	.table tbody tr:hover{
	   background-color:rgb(222, 225, 229);
	   color:#030303;
	   cursor: pointer;
   	}
   	table div{
    	padding: 0.45rem;
   	}
   	.table td{
     	padding: 0 !important;
   	}
</style>
<script>
	import agreements_service from './agreements_service'
	import tc_service from '../trucking_companies/tc_service'
	import ec_service from '../energy_companies/ec_service'
	import vSelect from 'vue-select'
	const items = []
	const fields = [
		{ key: 'id', label: 'ID', sortable: true },
		{ key: 'energy_company', label: 'Energy Company', sortable: true },
		{ key: 'trucking_company', label: 'Trucking Company', sortable: true },
		{ key: 'initial_date', label: 'Initial Date', sortable: true },
		{ key: 'end_date', label: 'End Date', sortable: true },
		{ key: 'cost_type', label: 'Cost Type', sortable: true},
		{ key: 'rate', label: 'Rate', sortable: true },
		{ key: 'charge_type', label: 'Charge Type'},
		{ key: 'truck_type', label: 'Truck Type', sortable: true},
		{ key: 'status', label: 'Status'}]
	export default {
		name: 'agreements',
		components: {
			vSelect
		},
		created: function () {
	      this.getAll()
	    },
		data () {
			return {
				trash					: false,
				dpdt					: 'Active',
				insert_data		: null,
				newAgreements	: false,
				items					: [],
				itemsO				: [],
				//initialDate: '',
				//endDate: '',
				//rate: '',
				
				//selectedChargeType: '',
				//selectedTruckingC: '',
				//selectedEnergyC: '',
				//selectedtruckTypesC: '',
				chargeTypes		: [],
				// costTypes: [],
				// selectedCostType: '',
				
				loadingData		: true,
				currentPage		: 1,
				perPage				: 25,
				totalRows			: items.length,
				pageOptions		: [ 25, 50, 100 ],
				sortBy				: 'initial_date',
				sortDesc			: false,
				fields				: fields,
				fieldsTh			: [
					//{ key: 'details', label: 'Details'},
					{ key: 'id', label: 'ID', sortable: true },
					{ key: 'energy_company', label: 'Energy Company', sortable: true },
					{ key: 'trucking_company', label: 'Trucking Company', sortable: true },
					{ key: 'load_locations_l', label: 'Load Locations', sortable: false },
					{ key: 'unload_locations_l', label: 'Unload Locations', sortable: false },
					{ key: 'fluidtypes', label: 'Fluid Types', sortable: false },
					{ key: 'truck_types_l', label: 'Truck Types', sortable: false },
					// { key: 'initial_date', label: 'Initial Date', sortable: true},
					{ key: 'initial_date', label: 'Initial Date', sortable: true, formatter:(value) => { return moment(value).format("LL")} },
					// { key: 'initial_date', label: 'Initial Date', sortable: true, formatter:(value) => { return new Date(value)} },
					{ key: 'end_date', label: 'End Date', sortable: true, formatter:(value) => { return moment(value).format("LL")}   },
					{ key: 'regular_charge', label: 'Regular Charge Type'},
					{ key: 'regular_rate', label: 'Regular Rate', sortable: true },
					{ key: 'stb_charge', label: 'Standby Time Charge Type'},
					{ key: 'stb_rate', label: 'Standby Time Rate', sortable: true },
					{ key: 'worktime_rate', label: 'Worktime Rate', sortable: true },
					{ key: 'located_based', label: 'Located Based Contract', sortable: true },
					{ key: 'fluidtypes_based', label: 'Fluid Types Based Contract', sortable: true },
					{ key: 'chain_up_rate', label: 'Chain Up Rate', sortable: true },
					
				],
				filter			: null,
				modalInfo		: { title: '', content: '' },
				configTable	: false,
				selectedItems: ['id','initial_date','end_date', 'rate', 'energy_company', 'trucking_company', 'charge_type'],

				role				:'',
				savebtn			:true,
				energy_company_iidd :null,
				model:{
					id						: null,
					energy_company_id		: null,
					trucking_company_id 	: null,
					initial_date			: null,
					end_date				: null,
					regular_charge_id		: null,
					regular_rate			: null,
					stb_charge_id			: null,
					stb_rate				: null,
					worktime_charge_id		: null,
					worktime_rate			: null,
					chain_up_rate			: null,
					truck_type_id			: [],
					unload_locations_id 	: [],
					load_locations_id		: [],
					located_based			: 'false',
					rounding 				: 'false',
					wait_time_discount 		: 'false',
					fluid_based			    : 'false',
					fluid_types_id          : [],
					fluid_types             : [],
				},
				energyCompanies				: [],
				truckingCompanies			: [],		
				modalTabIndex				: 0,
				unloadlocationselect		: [],
				indeterminateUL				: false,
				ulAllSelected				: false,
				loadlocationselect			: [],
				indeterminateLL				: false,
				llAllSelected				: false,
				truckTypes					: [],
				indeterminateTT				: false,
				ttAllSelected				: false,
				options: [
          			{ text: 'Yes', value: 'true' },
          			{ text: 'No', value: 'false' },
				],
				options1: [
          			{ text: 'Yes', value: 'true' },
          			{ text: 'No', value: 'false' },
				],
				regular_rate				: '',
				chain_up_rate				: '',
				stb_rate					: '',
				worktime_rate				: '',
				trucking_companies_filter 	: [],
				energy_companies_filter 	: [],
				unload_locations_filter 	: [],
				load_locations_filter   	: [],
				truck_types_filter   		: [],
				filter_agree				:{	trucking_company:'All Trucking Companies',
												energy_company  :'All Energy Companies',
												load_locations  :'All Load Locations',
												load_locations_id :0,
												unload_locations:'All Unload Locations',
												unload_locations_id :0,
												truck_types 			:'All Truck Types',
												truck_types_id		:0,
											},
				fluidtypeselect				: [],
				indeterminateFT				: false,
				ftAllSelected				: false,
			}
		},
		computed: {
	      sortOptions () {
	        // Create an options list from our fields
	        return this.fieldsTh
	          .filter(f => f.sortable)
	          .map(f => { return { text: f.label, value: f.key } })
	      }
	    },
	    methods: {
			activate_custom_backdrop() {
        		this.$root.$el.classList.add("custom_backdrop_behavior");
      		},
      		deactivate_custom_backdrop() {
        		this.$root.$el.classList.remove("custom_backdrop_behavior");
	  		},
	    	tcFilter(tc_filter,id) {
					this.filter_agree.trucking_company = tc_filter
					let result = []
					if (this.filter_agree.trucking_company==='All Trucking Companies') {
						result = this.itemsO
					} else {
						result = this.itemsO.filter(item => {return item.trucking_company==this.filter_agree.trucking_company})
					}
					let result1 = []
					if (this.filter_agree.energy_company == 'All Energy Companies') {
							result1 = result
					} else {
							result1 = result.filter(item => {return item.energy_company==this.filter_agree.energy_company});
					}
					let result2 = []
					if (this.filter_agree.load_locations == 'All Load Locations') {
							result2 = result1
					} else {
							result2 = result1.filter(item => {return item.load_locations==this.filter_agree.load_locations});
					}
					let result3 = []
					if (this.filter_agree.unload_locations == 'All Unload Locations') {
							result3 = result2
					} else {
							result3 = result2.filter(item => { let ok = false; 
						                                          if (item.unload_locations.indexOf(this.filter_agree.unload_locations_id)>-1){ ok=true}; return ok});
					}
					let result4 = []
					if (this.filter_agree.truck_types == 'All Truck Types') {
							result4 = result3
					} else {
							result4 = result3.filter(item => { let ok = false; 
						                                          if (item.truck_types.indexOf(this.filter_agree.truck_types_id)>-1){ ok=true}; return ok});
					}
					this.items = result4
					this.filters_agree_update()
			},
			ecFilter(ec_filter,id) {
				this.filter_agree.energy_company = ec_filter
				let result = []
				if (this.filter_agree.energy_company == 'All Energy Companies') {
					result = this.itemsO
				} else {
					result = this.itemsO.filter(item => {return item.energy_company==this.filter_agree.energy_company});
				}
				let result1 = []
				if (this.filter_agree.trucking_company==='All Trucking Companies') {
					result1 = result
				} else {
					result1 = result.filter(item => {return item.trucking_company==this.filter_agree.trucking_company});
				}
				let result2 = []
				if (this.filter_agree.load_locations == 'All Load Locations') {
						result2 = result1
				} else {
						result2 = result1.filter(item => { let ok = false; 
																if (item.load_locations.indexOf(this.filter_agree.load_locations_id)>-1){ ok=true}; return ok});
				}
				let result3 = []
				if (this.filter_agree.unload_locations == 'All Unload Locations') {
						result3 = result2
				} else {
						result3 = result2.filter(item => { let ok = false; 
																if (item.unload_locations.indexOf(this.filter_agree.unload_locations_id)>-1){ ok=true}; return ok});
				}
				let result4 = []
				if (this.filter_agree.truck_types == 'All Truck Types') {
						result4 = result3
				} else {
						result4 = result3.filter(item => { let ok = false; 
																if (item.truck_types.indexOf(this.filter_agree.truck_types_id)>-1){ ok=true}; return ok});
				}
				this.items = result4
				this.filters_agree_update()
			},
			lFilter(ul_filter,id) {
				this.filter_agree.load_locations		= ul_filter
				this.filter_agree.load_locations_id	= id
				let result = []
				if (this.filter_agree.load_locations == 'All Load Locations') {
						result = this.itemsO
				} else {
						result = this.itemsO.filter(item => { let ok = false; 
																if (item.load_locations.indexOf(this.filter_agree.load_locations_id)>-1){ ok=true}; return ok});
				}
				let result1 = []
				if (this.filter_agree.trucking_company==='All Trucking Companies') {
					result1 = result
				} else {
					result1 = result.filter(item => {return item.trucking_company==this.filter_agree.trucking_company});
				}
				let result2 = []
				if (this.filter_agree.energy_company == 'All Energy Companies') {
					result2 = result1
				} else {
					result2 = result1.filter(item => {return item.energy_company==this.filter_agree.energy_company});
				}
				let result3 = []
				if (this.filter_agree.unload_locations == 'All Unload Locations') {
						result3 = result2
				} else {
						result3 = result2.filter(item => { let ok = false; 
																if (item.unload_locations.indexOf(this.filter_agree.unload_locations_id)>-1){ ok=true}; return ok});
				}
				let result4 = []
				if (this.filter_agree.truck_types == 'All Truck Types') {
						result4 = result3
				} else {
						result4 = result3.filter(item => { let ok = false; 
																if (item.truck_types.indexOf(this.filter_agree.truck_types_id)>-1){ ok=true}; return ok});
				}
				this.items = result4
				this.filters_agree_update()
			},
			uFilter(ul_filter,id) {
				this.filter_agree.unload_locations		= ul_filter
				this.filter_agree.unload_locations_id	= id
				let result = []
				if (this.filter_agree.unload_locations == 'All Unload Locations') {
						result = this.itemsO
				} else {
						result = this.itemsO.filter(item => { let ok = false; 
																if (item.unload_locations.indexOf(this.filter_agree.unload_locations_id)>-1){ ok=true}; return ok});
				}
				let result1 = []
				if (this.filter_agree.trucking_company==='All Trucking Companies') {
					result1 = result
				} else {
					result1 = result.filter(item => {return item.trucking_company==this.filter_agree.trucking_company});
				}
				let result2 = []
				if (this.filter_agree.energy_company == 'All Energy Companies') {
					result2 = result1
				} else {
					result2 = result1.filter(item => {return item.energy_company==this.filter_agree.energy_company});
				}
				let result3 = []
				if (this.filter_agree.load_locations == 'All Load Locations') {
						result3 = result2
				} else {
						result3 = result2.filter(item => { let ok = false; 
																if (item.load_locations.indexOf(this.filter_agree.load_locations_id)>-1){ ok=true}; return ok});
				}
				let result4 = []
				if (this.filter_agree.truck_types == 'All Truck Types') {
						result4 = result3
				} else {
						result4 = result3.filter(item => { let ok = false; 
																if (item.truck_types.indexOf(this.filter_agree.truck_types_id)>-1){ ok=true}; return ok});
				}
				this.items = result4
				this.filters_agree_update()
			},
			filters_init() {
				let result = []
				if (this.filter_agree.truck_types == 'All Truck Types') {
						result = this.itemsO
				} else {
						result = this.itemsO.filter(item => { let ok = false; 
																if (item.truck_types.indexOf(this.filter_agree.truck_types_id)>-1){ ok=true}; return ok});
				}
				let result1 = []
				if (this.filter_agree.trucking_company==='All Trucking Companies') {
					result1 = result
				} else {
					result1 = result.filter(item => {return item.trucking_company==this.filter_agree.trucking_company});
				}

				let result2 = []
				if (this.filter_agree.energy_company == 'All Energy Companies') {
					result2 = result1
				} else {
					result2 = result1.filter(item => {return item.energy_company==this.filter_agree.energy_company});
				}
				let result3 = []
				if (this.filter_agree.load_locations == 'All Load Locations') {
							result3 = result2
				} else {
						result3 = result2.filter(item => { let ok = false; 
																if (item.load_locations.indexOf(this.filter_agree.load_locations_id)>-1){ ok=true}; return ok});
				}
				let result4 = []
				if (this.filter_agree.unload_locations == 'All Unload Locations') {
						result4 = result3
				} else {
						result4 = result3.filter(item => { let ok = false; 
																if (item.unload_locations.indexOf(this.filter_agree.unload_locations_id)>-1){ ok=true}; return ok});
				}
				this.items = result4
			},
			ttFilter(ul_filter,id) {
				this.filter_agree.truck_types				= ul_filter
				this.filter_agree.truck_types_id		= id
				let result = []
				if (this.filter_agree.truck_types == 'All Truck Types') {
						result = this.itemsO
				} else {
						result = this.itemsO.filter(item => { let ok = false; 
																if (item.truck_types.indexOf(this.filter_agree.truck_types_id)>-1){ ok=true}; return ok});
				}
				let result1 = []
				if (this.filter_agree.trucking_company==='All Trucking Companies') {
					result1 = result
				} else {
					result1 = result.filter(item => {return item.trucking_company==this.filter_agree.trucking_company});
				}
				let result2 = []
				if (this.filter_agree.energy_company == 'All Energy Companies') {
					result2 = result1
				} else {
					result2 = result1.filter(item => {return item.energy_company==this.filter_agree.energy_company});
				}
				let result3 = []
				if (this.filter_agree.load_locations == 'All Load Locations') {
						result3 = result2
				} else {
						result3 = result2.filter(item => { let ok = false; 
																if (item.load_locations.indexOf(this.filter_agree.load_locations_id)>-1){ ok=true}; return ok});
				}
				let result4 = []
				if (this.filter_agree.unload_locations == 'All Unload Locations') {
						result4 = result3
				} else {
						result4 = result3.filter(item => { let ok = false; 
																if (item.unload_locations.indexOf(this.filter_agree.unload_locations_id)>-1){ ok=true}; return ok});
				}
				this.items = result4
				this.filters_agree_update()
			},
			trucktypesChange() {
				if (this.role =='super_admin') {
					if (this.model.truck_type_id.length === 0) {
					this.indeterminateTT = false
					this.ttAllSelected = false
					} else if (this.model.truck_type_id.length === this.truckTypes.length) {
					this.indeterminateTT = false
					this.ttAllSelected = true
					} else {
					this.indeterminateTT = true
					this.ttAllSelected = false
					}
				}
			},
			ttToggleAll(checked) {
				this.model.truck_type_id = checked ? this.truckTypes.map(item => {
					return item.id
				}) : []
			},
			loadLocationsChange() {
				if (this.role =='super_admin') {
					if (this.model.load_locations_id.length === 0) {
					this.indeterminateLL = false
					this.llAllSelected = false
					} else if (this.model.load_locations_id.length === this.loadlocationselect.length) {
					this.indeterminateLL = false
					this.llAllSelected = true
					} else {
					this.indeterminateLL = true
					this.llAllSelected = false
					}
				}
			},
			LLToggleAll(checked) {
				this.model.load_locations_id = checked ? this.loadlocationselect.map(item => {
					return item.id
				}) : []
			},
			unloadLocationsChange() {
				if (this.role =='super_admin') {
					if (this.model.unload_locations_id.length === 0) {
					this.indeterminateUL = false
					this.ulAllSelected = false
					} else if (this.model.unload_locations_id.length === this.unloadlocationselect.length) {
					this.indeterminateUL = false
					this.ulAllSelected = true
					} else {
					this.indeterminateUL = true
					this.ulAllSelected = false
					}
				}
			},
			ULToggleAll(checked) {
				this.model.unload_locations_id = checked ? this.unloadlocationselect.map(item => {
					return item.id
				}) : []
			},
			myOnlyNumber(evt, variableName) {
				let dotPosition = this[variableName].indexOf(".")
				let hasDot = dotPosition > -1
				let length = this[variableName].length
				this.isNumber(evt, hasDot, dotPosition, length)
			},
			isNumber: function(evt, hasDot, dotPosition, length) {
				evt = (evt) ? evt : window.event;
				var charCode = (evt.which) ? evt.which : evt.keyCode;
				if (charCode <= 31 || charCode == 37 || charCode == 39 || (charCode >= 96 && charCode <= 105) || ((charCode >= 48 && charCode <= 57) || charCode === 46 || charCode === 19 || (!hasDot && charCode == 190)|| (!hasDot && charCode == 110))) {
					let selectionStart = evt.target.selectionStart;
					let selectionEnd = evt.target.selectionEnd;
					if ((hasDot && selectionEnd > dotPosition && length - 2 > dotPosition) && charCode > 31 && (charCode != 37 && charCode != 39)) {
						evt.preventDefault();
					} else {
						return true
					}
				} else {
					evt.preventDefault();
				}
			},
			select_energy_companies() {

					this.truckTypes = []
					this.indeterminateUL	= false
					this.ulAllSelected		= false
					this.indeterminateLL	= false
					this.llAllSelected		= false
					this.model.unload_locations_id = []
					this.model.load_locations_id	= []

					let energycompanies = this.insert_data.energy_companies
					let energy_company_index = energycompanies.map(o => o.id).indexOf(this.model.energy_company_id)
					if (energy_company_index > -1) {
					this.loadlocationselect  = energycompanies[energy_company_index]['load_locations']
					this.unloadlocationselect= energycompanies[energy_company_index]['unload_locations']
					let trucking_companies = energycompanies[energy_company_index]['trucking_companies']
					this.truckingCompanies = trucking_companies.map(item => {
						return { 'value': item.id, 'text': item.name }
					})
					// SAME as in APP - Select if there is only one item in the array
					if (this.truckingCompanies.length == 1) {
						this.model.trucking_company_id = this.truckingCompanies[0].value

						let trucking_companies = energycompanies[energy_company_index]['trucking_companies']
						let trucking_company_index = trucking_companies.map(o => o.id).indexOf(this.model.trucking_company_id)
						if (trucking_company_index > -1) {
							let truck_types = trucking_companies[trucking_company_index]['truck_types']
							this.truckTypes = truck_types
						}
					} else {
						this.model.trucking_company_id  = null
				}
				}

			},
			select_trucking_companies() {

			this.indeterminateTT	= false
			this.ttAllSelected		= false
			this.model.truck_type_id		= []
			if (this.role =='super_admin') {
				let energycompanies = this.insert_data.energy_companies
				let energy_company_index = energycompanies.map(o => o.id).indexOf(this.model.energy_company_id)
				if (energy_company_index > -1) {
					let trucking_companies = energycompanies[energy_company_index]['trucking_companies']
					let trucking_company_index = trucking_companies.map(o => o.id).indexOf(this.model.trucking_company_id)
					if (trucking_company_index > -1) {
						let truck_types = trucking_companies[trucking_company_index]['truck_types']
						this.truckTypes = truck_types
					}
				}
			} else if (this.role =='super_analyst' || this.role =='analyst' || this.role =='marketing_accountant') {
						let trucking_companies = this.insert_data.energy_companies[0].trucking_companies
			let trucking_company_index = trucking_companies.map(o => o.id).indexOf(this.model.trucking_company_id)
						if (trucking_company_index > -1) {
							let truck_types = trucking_companies[trucking_company_index]['truck_types']
							this.truckTypes = truck_types
					}
			}
			},
			rowClicked(row) {
				if(!this.trash) {
					this.$router.push('/agreement/'+row.id+'/')
				} else {
					this.restoreAgreement(row.id)
				}
			},
	    	onFiltered (filteredItems) {
		    	// Trigger pagination to update the number of buttons/pages due to filtering
		    	this.totalRows = filteredItems.length
		    	this.currentPage = 1
		    },
		    reload () {
		        this.getAll()
		    },
		    info (item, index, button) {
		        this.modalInfo.title = `Row: ${index + 1}`
		        this.modalInfo.content = JSON.stringify(item, null, 2)
		        this.$root.$emit('bv::show::modal', 'modalInfo', button)
		    },
		    resetModal () {
		        this.modalInfo.title = ''
		        this.modalInfo.content = ''
		    },
		    resetNewModal () {
		    	this.initialDate = ''
		    	this.endDate = ''
		    	this.rate = ''
		    	this.chain_up_rate = ''
		    	this.selectedChargeType = ''
		    	this.selectedTruckingC = ''
					this.selectedEnergyC = ''
					this.selectedtruckTypesC = ''
			},
			showNewModal() {
					this.model={
						id						: null,
						energy_company_id		: null,
						trucking_company_id 	: null,
						initial_date			: null,
						end_date				: null,
						regular_charge_id		: null,
						regular_rate			: null,
						stb_charge_id			: null,
						stb_rate				: null,
						worktime_charge_id		: null,
						worktime_rate			: null,
						chain_up_rate			: null,
						truck_type_id			: [],
						unload_locations_id 	: [],
						load_locations_id		: [],
						located_based			: 'false',
						rounding 				: 'false',
						wait_time_discount 		: 'false',
						fluid_based				: 'false',
						fluid_types_id          : [],
						fluid_types             : [],
					}
				if (this.role =='super_admin') {
					this.truckingCompanies=[]
				}
					this.truckTypes						= []
					this.indeterminateUL	= false
					this.ulAllSelected		= false
					this.indeterminateLL	= false
					this.llAllSelected		= false
					this.indeterminateTT	= false
					this.ttAllSelected		= false
					this.savebtn			= false
					this.newAgreements		= true
					this.indeterminateFT			= false
					this.ftAllSelected			= false
			},
		    cancelNew () {
		    	this.$refs.newAgreements.hide()
		    },
		    goTo( item ) {
		    	this.$router.push('/users/' + item.id)
				},
			trashAgreement() {
					this.trash = !this.trash
					this.dpdt = this.trash ? "Trash" : "Active"
          this.getAll()
          this.loadingData = true
        	},
		    getAll () {
		    	this.loadingData = true
		        agreements_service.getAll()
		          .then(data => {
		            if (data[0] == 'success') {
						if(data[2]) {
							this.insert_data = data[2]
							this.energy_companies_filter 		= this.insert_data.energy_companies
							this.trucking_companies_filter		= this.insert_data.trucking_companies_filter						
							this.unload_locations_filter  		= this.insert_data.locations_unload
							this.load_locations_filter  		= this.insert_data.locations_load
							this.truck_types_filter  		    = this.insert_data.truck_types_filter
							this.filter_agree 					= this.insert_data.filters
							// this.unloadlocationselect  			= this.insert_data.locations_unload
							this.fluidtypeselect  				= this.insert_data.fluid_types
							if (this.insert_data.charge_types.length>0) {
								this.chargeTypes = this.insert_data.charge_types.map(item => {
									return { text: item.name, value: item.id }
								})								
							} else {
								this.chargeTypes = []
							}
							
							this.role = data[3]
							if (this.role =='super_admin') {
								this.energyCompanies = this.insert_data.energy_companies.map(item => {
									return { text: item.company_name, value: item.id }
								})
							} else if (this.role =='super_analyst' || this.role =='analyst' || this.role =='marketing_accountant') {
								this.energy_company_iidd = data[4]
								let trucking_companies = this.insert_data.energy_companies[0].trucking_companies
								this.truckingCompanies = trucking_companies.map(item => {
									return { 'value': item.id, 'text': item.name }
								})
									this.loadlocationselect  = this.insert_data.energy_companies[0].load_locations
									this.unloadlocationselect  = this.insert_data.energy_companies[0].unload_locations
							} 
						}
						this.items  = data[1].filter(o => o.status_id == (this.trash ? 2 : 1))
						this.itemsO = this.items
						this.filters_init()
		            } else {
						this.items 	= []
						this.itemsO	= this.items
		            	this.$swal(data[0], data[1], data[0])
		            }
		            this.loadingData = false
		          })
		          .catch(error => {
		            this.$swal('Error', 'Server not response. ' + error, 'error')
		            this.loadingData = false
		          })
		    },
		    saveAgreements () {
					if (this.selectedCostType ==2) {
						this.chain_up_rate = 0
					}
					if(!this.okToSave()) {
          				return
					}
					this.savebtn=true
					if (this.role =='super_admin') {
							this.energy_company_iidd = this.model.energy_company_id
					} else if (this.role =='super_analyst' || this.role =='analyst' || this.role =='marketing_accountant') {
							this.model.energy_company_id = this.energy_company_iidd
					}
					if(this.model.fluid_based	 == 'true') {
						let fluid_types_id =   this.model.fluid_types_id   
						let new_fluid_types = []
						let index = -1
						fluid_types_id.forEach(e => {
							if (this.fluidtypeselect.length != 0) {
								index = this.fluidtypeselect.map(o => o.id).indexOf(e)
								if (index>-1) {
									new_fluid_types.push(this.fluidtypeselect[index])
								} 
							}
						})
						this.model.fluid_types = new_fluid_types
					}

					agreements_service.verify( this.model )
					.then(data => {
						if (data[0] == 'success') {
							agreements_service.save( this.model )
								.then(data => {
									this.$swal(data[0], data[1], data[0])
									.then((result) => {
										if (data[0] == 'success') {
											this.newAgreements = false
											this.getAll()
										}
									})
								})
								.catch(error => {
									this.$swal('Error', 'Server not response. ' + error, 'error')
								})
						} else{
							 if (data[2].length>0) {
								 						this.$swal({
															title: 'Please, confirm',
															text: "Hauls with contracts. Would you like assign them to this agreement?",
															type: 'question',
															showCancelButton: true,
															confirmButtonColor: '#3085d6',
															cancelButtonColor: '#d33',
															confirmButtonText: 'Yes',
															reverseButtons: true
														}).then((result) => {
																	if (result.value) {
																		agreements_service.save( this.model )
																		.then(data => {
																			this.$swal(data[0], data[1], data[0])
																			if (data[0] == 'success') {
																				this.newAgreements = false
																				this.getAll()
																			}
																		})
																		.catch(error => {
																			this.$swal('Error', 'Server not response. ' + error, 'error')
																		})
						}
					})
								 	console.log('Hauls with contracts')
							 } else {
								 	this.$swal(data[0], data[1], data[0])
							 }
						}
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
					})
					this.savebtn=false
			},
			restoreAgreement(id) {
					this.$swal({
						title: 'Please, confirm',
						text: "Are you sure to restore this Agreement?",
						type: 'question',
						showCancelButton: true,
						confirmButtonColor: '#3085d6',
						cancelButtonColor: '#d33',
						confirmButtonText: 'Yes',
						reverseButtons: true
					}).then((result) => {
						if (result.value) {
							agreements_service.restore(id)
								.then(data => {
									this.$swal(data[0], data[1], data[0])
									if (data[0] == 'success') {
										this.filter = ''
										this.trash = false
										this.getAll()
										this.loadingData = true
									}
								})
								.catch(error => {
									this.$swal('Error', 'Server not response. ' + error, 'error')
								})
						}
					})
			},
			okToSave() {

					if (this.role =='super_admin') {
						if( this.model.energy_company_id == null) {
							this.$swal('Alert!', 'Energy Company not selected', 'warning')
							return false
						}
					}

					if(this.model.initial_date === undefined || this.model.initial_date == null) {
						this.$swal('Alert!', 'Initial Date not selected', 'warning')
						return false
					} else if(this.model.end_date === undefined || this.model.end_date == null) {
						this.$swal('Alert!', 'End Date not selected', 'warning')
						return false
					} else if(this.model.trucking_company_id === undefined || this.model.trucking_company_id  == null) {
						this.$swal('Alert!', 'Trucking Company not selected', 'warning')
						return false
					} else if(this.model.regular_charge_id === undefined || this.model.regular_charge_id == null) {
						this.$swal('Alert!', 'Regular Charge Type not selected', 'warning')
						return false
					} else if(this.model.regular_rate === undefined || this.model.regular_rate == null || this.model.regular_rate == '') {
						this.$swal('Alert!', 'Regular Rate can not be empty', 'warning')
						return false
					} else if(this.model.truck_type_id.length == 0) {
						this.$swal('Alert!', 'Truck Types not selected', 'warning')
						return false
					} else if(this.model.stb_charge_id === undefined || this.model.stb_charge_id == null) {
						this.$swal('Alert!', 'Standby Time Charge Type not selected', 'warning')
						return false
					} else if(this.model.stb_rate === undefined || this.model.stb_rate == null || this.model.stb_rate == '') {
						this.$swal('Alert!', 'Standby Time Rate can not be empty', 'warning')
						return false
					} else if(this.model.worktime_charge_id === undefined || this.model.worktime_charge_id == null) {
						this.$swal('Alert!', 'Worktime Charge Type not selected', 'warning')
						return false
					} else if(this.model.worktime_rate === undefined || this.model.worktime_rate == null || this.model.worktime_rate == '') {
						this.$swal('Alert!', 'Worktime Rate can not be empty', 'warning')
						return false
					} else if(this.model.located_based	 == 'true' && this.model.load_locations_id.length == 0) {
						this.$swal('Alert!', 'Load Location not selected', 'warning')
						return false
					} else if(this.model.located_based	 == 'true' && this.model.unload_locations_id.length == 0) {
						this.$swal('Alert!', 'Unload Location not selected', 'warning')
						return false
					} else if(this.model.fluid_based	 == 'true' && this.model.fluid_types_id.length == 0) {
						this.$swal('Alert!', 'Fluid Types not selected', 'warning')
						return false
					}

					return true
			},
		    editItemMdoule ( item ) {
		    	alert(item.id)
		    },
		    deleteItemMdoule ( item ) {
		    	alert(item.id)
			},
			filters_agree_update() {
        	agreements_service.filters_agree(this.filter_agree)
          	.then((data) => {
                if (data[0] == 'success') {
										console.log('filters updated')
                } else {
                    this.$swal(data[0], data[1], data[0])
                }
          })
          	.catch(error => {
            		this.$swal('Error', 'Server not response. ' + error, 'error')
          	})
    		},
			FTToggleAll(checked) {
				this.model.fluid_types_id = checked ? this.fluidtypeselect.map(item => {
					return item.id
				}) : []
			},
			fluidtypesChange() {
				if (this.model.fluid_types_id.length === 0) {
					this.indeterminateFT = false
					this.ftAllSelected = false
				} else if (this.model.fluid_types_id.length === this.fluidtypeselect.length) {
					this.indeterminateFT = false
					this.ftAllSelected = true
				} else {
					this.indeterminateFT = true
					this.ftAllSelected = false
				}
			},
	    }
	}
</script>
<style scoped>
	/deep/ .nav-link.active {
		font-weight: bold;
	} 
	/deep/ .col-form-label{
		font-weight: bold;
	}
	/deep/ .modal-lg {
    	max-width: 1000px;
	}
	/deep/	.custom-checkboxes .form-check-inline {
		width: 35vh;
	}
	/deep/	.custom-checkboxes .form-check-label {
    	overflow: unset;
	}
	.card-body >>> .b-table.table.b-table-stacked > tbody > tr > [data-label] {
		display: grid;
		grid-template-columns: 15% 85%;
		grid-gap: 0.25rem 1rem;
	}
</style>



// WEBPACK FOOTER //
// src/views/agreements/agreements.vue